import { clsx } from 'clsx'
import { type FC } from 'react'

import { useProductAddToCartQuantitySelectionDiscountBadgeData } from '../ProductBuyBox/ProductAddToCartGroup/ProductAddToCartQuantitySelection/useProductAddToCartQuantitySelectionDiscountBadgeData'

export const ProductPageVolumePricingCompactDiscountBadge: FC<{
  className?: string
  selectedValue: number
}> = ({ className, selectedValue }) => {
  const { discount } =
    useProductAddToCartQuantitySelectionDiscountBadgeData(selectedValue)

  if (discount && discount > 0) {
    return (
      <div
        className={clsx(
          'inline-block items-center justify-center rounded-full bg-light-brand-high p-[5px] text-xs font-medium text-dark-primary-max',
          className,
        )}
      >
        {`-${discount}%`}
      </div>
    )
  }

  return null
}
